import Icon from '../components/Icon.vue'

Icon.register({
  toilet: {
    width: 384,
    height: 512,
    paths: [
      {
        d: 'M368 48C376.8 48 384 40.8 384 32V16C384 7.2 376.8 0 368 0H16C7.2 0 0 7.2 0 16V32C0 40.8 7.2 48 16 48H32V204.7C11.8 214.8 0 226.9 0 240 0 307.2 34.6 366.2 86.8 400.5L65.4 470.7C59.1 491.2 74.5 512 96 512H288C309.5 512 324.9 491.2 318.6 470.7L297.2 400.5C349.4 366.2 384 307.2 384 240 384 226.9 372.2 214.8 352 204.7V48H368zM80 72C80 67.6 83.6 64 88 64H136C140.4 64 144 67.6 144 72V88C144 92.4 140.4 96 136 96H88C83.6 96 80 92.4 80 88V72zM192 272C114.9 272 52.4 257.7 52.4 240S114.9 208 192 208 331.6 222.3 331.6 240 269.1 272 192 272z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/toilet.js
// module id = Xvfb
// module chunks = 144